/* Kunstpflanzenmarkt: Warenkorb-Lade.
 *
 * Logik aus Florages global.js übernommen, auf das reduziert, was KPM hat:
 *
 * - Öffnen und Schließen über einen Zustand am <html>-Element, damit
 *   Overlay, Lade und Scroll-Sperre an einer Stelle hängen.
 * - Hinzufügen und Mengenwechsel laufen über /cart/add und /cart/change,
 *   ohne Neuladen.
 * - Nach jeder Änderung rendert der Server die Lade neu
 *   (Section Rendering API). Hier wird nichts gerechnet. Die Versandlogik
 *   steht in Liquid, in sections/kpm-cart-drawer.liquid, und darf nicht
 *   ein zweites Mal in JavaScript entstehen.
 * - Fehlertexte kommen aus window.cartStrings, gesetzt im Layout.
 *
 * Der Warenkorb als Seite bleibt unberührt, der läuft weiter über
 * kpm-cart.js mit Neuladen.
 */

(function () {
  'use strict';

  var SECTION = 'kpm-cart-drawer';
  var root = document.documentElement;
  var letzterFokus = null;

  function wrapper() {
    return document.getElementById('shopify-section-' + SECTION);
  }

  function lade() {
    return document.querySelector('[data-kpm-drawer]');
  }

  function offen() {
    return root.classList.contains('kpm-cd-open');
  }

  function oeffnen() {
    var el = lade();
    if (!el) return;

    letzterFokus = document.activeElement;
    root.classList.add('kpm-cd-open');
    el.setAttribute('aria-hidden', 'false');

    var ov = document.querySelector('[data-kpm-drawer-overlay]');
    if (ov) ov.removeAttribute('hidden');

    // Fokus in die Lade, sonst tabbt der Nutzer hinter dem Overlay weiter.
    var ziel = el.querySelector('[data-kpm-drawer-close]') || el;
    ziel.focus();
  }

  function schliessen() {
    var el = lade();
    root.classList.remove('kpm-cd-open');
    if (el) el.setAttribute('aria-hidden', 'true');

    var ov = document.querySelector('[data-kpm-drawer-overlay]');
    if (ov) ov.setAttribute('hidden', '');

    if (letzterFokus && typeof letzterFokus.focus === 'function') letzterFokus.focus();
    letzterFokus = null;
  }

  function fehler(text) {
    var el = lade();
    if (!el) {
      window.alert(text);
      return;
    }
    var box = el.querySelector('[data-kpm-drawer-error]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-kpm-drawer-error', '');
      box.className = 'kpm-ship kpm-ship--spedition';
      box.style.padding = '12px var(--kpm-pad-x)';
      el.insertBefore(box, el.firstChild.nextSibling);
    }
    box.textContent = text;
  }

  function zaehlerSetzen(anzahl) {
    if (typeof anzahl !== 'number') return;
    document.querySelectorAll('[data-kpm-cart-count]').forEach(function (el) {
      el.textContent = anzahl;
    });
  }

  /* Lade serverseitig neu rendern. Der Pfad ist egal, die Sektion hängt
     nicht an der Seite, aber ein absoluter Pfad vermeidet Ärger mit
     Query-Parametern der aktuellen Seite. */
  function neuRendern() {
    var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return fetch(wurzel + '?sections=' + SECTION, {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Sektion nicht geladen');
        return r.json();
      })
      .then(function (daten) {
        var html = daten[SECTION];
        if (!html) return;

        var neu = new DOMParser().parseFromString(html, 'text/html');
        var quelle = neu.getElementById('shopify-section-' + SECTION);
        var ziel = wrapper();
        if (!quelle || !ziel) return;

        ziel.innerHTML = quelle.innerHTML;

        // Der Zustand am <html> bleibt, das neue Markup muss ihn spiegeln.
        var el = lade();
        if (el) el.setAttribute('aria-hidden', offen() ? 'false' : 'true');
        var ov = document.querySelector('[data-kpm-drawer-overlay]');
        if (ov && offen()) ov.removeAttribute('hidden');
      });
  }

  function mengeAendern(key, menge) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: menge }),
    })
      .then(function (r) {
        return r.json().then(function (daten) {
          if (!r.ok) throw new Error(daten.description || daten.message || '');
          return daten;
        });
      })
      .then(function (daten) {
        zaehlerSetzen(daten.item_count);
        return neuRendern();
      })
      .catch(function (e) {
        fehler(e.message || (window.cartStrings && window.cartStrings.error) || 'Warenkorb konnte nicht aktualisiert werden');
      });
  }

  document.addEventListener('click', function (event) {
    var oeffner = event.target.closest('[data-kpm-drawer-open]');
    if (oeffner) {
      event.preventDefault();
      oeffnen();
      return;
    }

    if (
      event.target.closest('[data-kpm-drawer-close]') ||
      event.target.closest('[data-kpm-drawer-overlay]')
    ) {
      event.preventDefault();
      schliessen();
      return;
    }

    var entfernen = event.target.closest('[data-kpm-drawer-remove]');
    if (entfernen) {
      event.preventDefault();
      mengeAendern(entfernen.getAttribute('data-kpm-drawer-remove'), 0);
      return;
    }

    var stufe = event.target.closest('[data-kpm-drawer-qty]');
    if (!stufe) return;

    event.preventDefault();
    var anzeige = stufe.parentElement.querySelector('span');
    var aktuell = parseInt(anzeige ? anzeige.textContent : '1', 10) || 1;
    var naechste = stufe.getAttribute('data-kpm-drawer-qty') === 'up' ? aktuell + 1 : aktuell - 1;
    if (naechste < 0) naechste = 0;

    mengeAendern(stufe.getAttribute('data-key'), naechste);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && offen()) schliessen();
  });

  /* In den Warenkorb legen, ohne die Produktseite zu verlassen.
     Greift nur bei echten /cart/add-Formularen. Das Kassen-Formular in der
     Lade zeigt auf /cart und bleibt unberührt. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!lade()) return;

    event.preventDefault();

    var knopf = form.querySelector('[type="submit"]');
    if (knopf) knopf.setAttribute('aria-busy', 'true');

    var daten = new FormData(form);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: daten,
    })
      .then(function (r) {
        return r.json().then(function (antwort) {
          if (!r.ok) throw new Error(antwort.description || antwort.message || '');
          return antwort;
        });
      })
      .then(function () {
        return neuRendern();
      })
      .then(function () {
        return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.json();
          })
          .then(function (warenkorb) {
            zaehlerSetzen(warenkorb.item_count);
          })
          .catch(function () {
            /* Zähler ist Beiwerk, die Lade zeigt die Wahrheit. */
          });
      })
      .then(function () {
        oeffnen();
      })
      .catch(function (e) {
        oeffnen();
        fehler(e.message || (window.cartStrings && window.cartStrings.error) || 'Konnte nicht hinzugefügt werden');
      })
      .finally(function () {
        if (knopf) knopf.removeAttribute('aria-busy');
      });
  });
})();
